import { ENV } from './environments'

// MIRAGEJS / MOCK SERVER
// there is some issue with miragejs (mock server) that causes console.log to not work
// if console.log will not work for you please use reactotron (USE_REACTOTRON = true)
export const ENABLE_MOCKED_SERVER = true

// MOCK ONLY UNAVAILABLE BE ENDPOINTS:
// true - mock only unavailable endpoints
// false - mock all available endpoints besides of '/me', '/sign-in' and '/verify-otp'
export const USE_MINIMAL_MOCK = true

// REACTOTRON
const USE_REACTOTRON = false
export const USING_REACTOTRON = USE_REACTOTRON || ENV.REACTOTRON === '1'

export const USE_OTP_VERiFICATION_FOR_SOME_USERS = false
